// src/features/counter/counterSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  oktauser: {},
  applications: [],
  flagUser: {},
};
export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setOktaUser(state, action) {
      state.oktauser = action.payload;
    },
    setUserApplications(state, action) {
      state.applications = action.payload;
    },
    setFlagUser(state, action) {
      state.flagUser = action.payload;
    },
  },
});

export const { setOktaUser, setUserApplications, setFlagUser } =
  userSlice.actions;

export default userSlice.reducer;
